import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "./http-service";
import { Http } from "@angular/http";
import { ToastrService } from "ngx-toastr";
import { InitProvider } from "./init-provider";
import * as CryptoJS from "crypto-js";
import { Configuracoes } from "../entities/configuracoes";
@Injectable({
  providedIn: "root",
})
export class SecurityService extends HttpService {
  public form;
  public callbackLoginOk;
  public callbackError;

  secretKey: string = "urnae245vjr5eosd";

  constructor(
    public router: Router,
    public http: Http,
    public toastService: ToastrService,
    public initProvider: InitProvider
  ) {
    super(http, toastService);
  }
  chave: string = "urnae245vjr5eosd";

  decryptData(encryptedData, secretKey) {
    try {
      const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
      const iv = CryptoJS.lib.WordArray.create(
        encryptedDataBytes.words.slice(0, 4),
        16
      );
      const encryptedMessage = CryptoJS.lib.WordArray.create(
        encryptedDataBytes.words.slice(4),
        encryptedDataBytes.sigBytes - 16
      );
      const key = CryptoJS.enc.Utf8.parse(secretKey);
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedMessage },
        key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error("Decryption failed:", e);
      return "";
    }
  }

  decryptAndShow(encrypted) {
    const secretKey = this.chave;
    const encryptedData = encrypted;

    if (encryptedData === "" || secretKey === "") {
      console.error("Encrypted data or secret key is empty.");
      return;
    }

    const decryptedData = this.decryptData(encryptedData, secretKey);
    return decryptedData;
  }
  generateHash(obj: string, salt: string): string {
    const jsonString = JSON.stringify(obj);
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedStr = CryptoJS.enc.Base64.stringify(
      iv.concat(encrypted.ciphertext)
    );
    return encryptedStr;
  }

  loginCipher(formLogin, callbackSuccess, callbackError) {
    this.form = formLogin;
    this.callbackLoginOk = callbackSuccess;
    this.callbackError = callbackError;
    let cripto = this.generateHash(
      JSON.stringify(formLogin),
      "urnae245vjr5eosd"
    );
    // if(Configuracoes.API_BRANCH === "43b7e7dd8c2ec4a32fff9fc475fc82a63fbfea70-petz"){
    //   this.post(
    //     "authV2",
    //     {dados: cripto},
    //     this.loginSuccess.bind(this),
    //     this.loginError.bind(this)
    //   );
    // } else {
    this.post(
      "auth",
      { dados: cripto },
      this.loginSuccessCipher.bind(this),
      this.loginError.bind(this)
    );
    // }
  }

  login(formLogin, callbackSuccess, callbackError) {
    if(Configuracoes.cypher){
      this.form = formLogin;
    this.callbackLoginOk = callbackSuccess;
    this.callbackError = callbackError;
    let cripto = this.generateHash(
      JSON.stringify(formLogin),
      "urnae245vjr5eosd"
    );
    // if(Configuracoes.API_BRANCH === "43b7e7dd8c2ec4a32fff9fc475fc82a63fbfea70-petz"){
    //   this.post(
    //     "authV2",
    //     {dados: cripto},
    //     this.loginSuccess.bind(this),
    //     this.loginError.bind(this)
    //   );
    // } else {
    this.post(
      "auth",
      { dados: cripto },
      this.loginSuccessCipher.bind(this),
      this.loginError.bind(this)
    );
    } else {

      this.form = formLogin;
      this.callbackLoginOk = callbackSuccess;
    this.callbackError = callbackError;
    this.post(
      "auth",
      formLogin,
      this.loginSuccess.bind(this),
      this.loginError.bind(this)
    );
  }
  }
  

  recuperaSenha(form, callbackSuccess, callbackError) {
    this.post("auth/recuperaSenha", form, callbackSuccess, callbackError);
  }

  loginSuccessCipher(resp) {
    this.initProvider.usuario = JSON.parse(this.decryptAndShow(resp.dados));
    localStorage.setItem("token", JSON.parse(this.decryptAndShow(resp.dados)).token);
    localStorage.setItem("tipoUsuario", JSON.parse(this.decryptAndShow(resp.dados)).tipo);
    this.toastService.info("Usuário logado com sucesso!");
    this.router.navigate([""]);
    this.callbackLoginOk(JSON.parse(this.decryptAndShow(resp.dados)));
    this.initProvider.load();
  }

  loginSuccess(resp) {
    this.initProvider.usuario = resp;
    localStorage.setItem("token", resp.token);
    localStorage.setItem("tipoUsuario", resp.tipo);
    this.toastService.info("Usuário logado com sucesso!");
    this.router.navigate([""]);
    this.callbackLoginOk(resp);
    //console.log('login usuario', resp);
  }


  loginError(error) {
    this.callbackError(error);
  }

  isType(type: string) {
    return (
      localStorage.getItem("tipoUsuario") != null &&
      localStorage.getItem("tipoUsuario") == type
    );
  }

  hasToken() {
    return window.localStorage.getItem("token") != null;
  }

  logout() {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("tipoUsuario");
    window.localStorage.removeItem("pedido");
    window.location.href = "/";
    this.initProvider.usuario = null;
  }
}
